import { useEffect, useState } from "react";

const colors = {
  success: "bg-green-600",
  error: "bg-red-600",
  warning: "bg-yellow-500",
  info: "bg-blue-600",
};

export default function Alert({
  message,
  type = "info",
  duration = 5000,
  onClose,
}) {
  const [visible, setVisible] = useState(true);
  const [closing, setClosing] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setClosing(true);
      setTimeout(() => {
        setVisible(false);
        onClose?.();
      }, 400);
    }, duration);

    return () => clearTimeout(timer);
  }, [duration, onClose]);

  if (!visible) return null;

  return (
    <div className="fixed top-5 right-5 z-50">
      <div
        className={`relative overflow-hidden text-white px-5 py-4 rounded-lg shadow-lg w-80
        ${colors[type]}
        ${closing ? "animate-slideOut" : "animate-slideIn"}`}
      >
        {/* Message */}
        <p className="text-sm font-medium">{message}</p>

        {/* Countdown line */}
        <div className="absolute bottom-0 left-0 h-1 w-full bg-white/30">
          <div
            className="h-full bg-white animate-progress"
            style={{ animationDuration: `${duration}ms` }}
          />
        </div>
      </div>
    </div>
  );
}
